import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './pages/Home';
import Post from './pages/Post';
import NotFound from './pages/404';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import './index.css';
import SocialMedia from './components/SocialMedia';
import HomeNav from './components/Nav/HomeNav';
import StudentNav from './components/Nav/StudentNav';
import VrijwilligerNav from './components/Nav/VrijwilligerNav';
import SintJozefPost from './components/SintJozefPost';
import DeVlietPost from './components/DeVlietPost';
import VrijwilligersGezocht from './components/Vrijwilliger_gezocht';
import ActiviteitenNav, { GeneralActiviteiten, NewActNav } from './components/Nav/ActiviteitenNav';
import VrijSoliciteren, { Job1, Job2, Job3, Job4, Job5, NewJob, Jobs } from './components/Jobs';
import Hero, { Hero1, Hero2, Hero3, Hero4 } from './components/Hero/Hero.js';
import DvDiensten_default, { DvDiensten_Kort, DvDiensten_Orie, DvDiensten_Vast, DvDiensten_Somp, DvDiensten_coma } from './components/Diensten/DV_Diensten.js';
import STJDiensten_default, { STJDiensten_Kort, STJDiensten_Orie, STJDiensten_Vast, STJDiensten_Somp, STJDiensten_Dagop, STJDiensten_Assist } from './components/Diensten/STJ_Diensten.js';

ReactDOM.render(
    <Router>
        <div>
            <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/404" component={NotFound} />
                <Route exact path="/posts/:id" render={(props) => <Post {...props} />} />
                <Route exact path="/social" component={SocialMedia} />
                <Route exact path="/wzc-sint-jozef" component={SintJozefPost} />
                <Route exact path="/wzc-de-vliet" component={DeVlietPost} />
                <Route exact path="/home-nav" component={HomeNav} />
                <Route exact path="/student-nav" component={StudentNav} />
                <Route exact path="/vrijwilligers-nav" component={VrijwilligerNav} />
                <Route exact path="/vrijwilligers-gezocht" component={VrijwilligersGezocht} />
                <Route exact path="/activiteiten-nav" component={ActiviteitenNav} />
                <Route exact path="/activiteiten-general" component={GeneralActiviteiten} />
                <Route exact path="/new-act-nav" component={NewActNav} />
                <Route exact path="/jobs" component={VrijSoliciteren} />
                <Route exact path="/jobs/jobs" component={Jobs} />
                <Route exact path="/jobs/job-1" component={Job1} />
                <Route exact path="/jobs/job-2" component={Job2} />
                <Route exact path="/jobs/job-3" component={Job3} />
                <Route exact path="/jobs/job-4" component={Job4} />
                <Route exact path="/jobs/job-5" component={Job5} />
                <Route exact path="/jobs/new-job" component={NewJob} />
                <Route exact path="/hero" component={Hero} />
                <Route exact path="/hero-1" component={Hero1} />
                <Route exact path="/hero-2" component={Hero2} />
                <Route exact path="/hero-3" component={Hero3} />
                <Route exact path="/hero-4" component={Hero4} />
                {/* DV Diensten */}
                <Route exact path="/dv-diensten" component={DvDiensten_default} />
                <Route exact path="/dv-diensten/coma" component={DvDiensten_coma} />
                <Route exact path="/dv-diensten/orie" component={DvDiensten_Orie} />
                <Route exact path="/dv-diensten/kort" component={DvDiensten_Kort} />
                <Route exact path="/dv-diensten/vast" component={DvDiensten_Vast} />
                <Route exact path="/dv-diensten/somp" component={DvDiensten_Somp} />
                {/* STJ Diensten */}
                <Route exact path="/stj-diensten" component={STJDiensten_default} />
                <Route exact path="/stj-diensten/dagop" component={STJDiensten_Dagop} />
                <Route exact path="/stj-diensten/orie" component={STJDiensten_Orie} />
                <Route exact path="/stj-diensten/kort" component={STJDiensten_Kort} />
                <Route exact path="/stj-diensten/vast" component={STJDiensten_Vast} />
                <Route exact path="/stj-diensten/somp" component={STJDiensten_Somp} />
                <Route exact path="/stj-diensten/assist" component={STJDiensten_Assist} />
            </Switch>
        </div>
    </Router>,
    document.getElementById('root')
);
